import { render } from "./upData-address.vue?vue&type=template&id=bbe59b5e&scoped=true"
import script from "./upData-address.vue?vue&type=script&lang=js"
export * from "./upData-address.vue?vue&type=script&lang=js"

import "./upData-address.vue?vue&type=style&index=0&id=bbe59b5e&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbe59b5e"]])

export default __exports__